import { Avatar } from './Avatar.component';

export default Avatar;
